import React from 'react'
import PropTypes from 'prop-types'
import { ShiftBadge } from './'

const badgesPosition = position => {
  switch (position) {
    case 'top-left':
      return ' absolute top-2 left-4'
    case 'top-right':
      return ' absolute top-2 right-4'
    case 'bottom-left':
      return ' absolute bottom-2 left-4'
    case 'bottom-right':
      return ' absolute bottom-2 right-4'
    default:
      return position
  }
}

function ShiftBadges ({ children, position }) {
  return (
    <div className={'shift-badges flex' + badgesPosition(position)}>
      {children}
    </div>
  )
}

ShiftBadges.defaultProps = {
  position: ''
}

ShiftBadges.propTypes = {
  /**
     * Controls the absolute position of the badges
     * Prop can be 'top-left', 'top-right', 'bottom-left', 'bottom-right'
     */
  position: PropTypes.string
}

export default ShiftBadges
